<script setup lang="ts">
  import {AdminPages, Model} from "@/app/Model";
  import AdminMenu from '@/components/admin/AdminMenu.vue'
  import AdminHome from '@/components/admin/AdminHome.vue'
  import AdminPenaleListaReatoRubrica from '@/components/admin/AdminPenaleListaReatoRubrica.vue'
  import AdminPenaleListaPenale from '@/components/admin/AdminPenaleListaPenale.vue'
  import AdminPenaleProcedure from '@/components/admin/AdminPenaleProcedure.vue'
  import AdminFamigliaListaFamiglia from '@/components/admin/AdminFamigliaListaFamiglia.vue'
  import AdminResponsabilitaListaResponsabilita from '@/components/admin/AdminResponsabilitaListaResponsabilita.vue'

  declare let gtagO: Function;
  let model: Model = Model.getReactiveInstance()
</script>

<template>
  <div class="row">
    <div class="col-2">
      <AdminMenu></AdminMenu>
    </div>
    <div class="col-10">
      <AdminHome v-if="model.adminPage == AdminPages.Home"></AdminHome>
      <AdminPenaleListaPenale v-if="model.adminPage == AdminPages.Penale_Penale"></AdminPenaleListaPenale>
      <AdminPenaleListaReatoRubrica v-if="model.adminPage == AdminPages.Penale_ReatoRubrica"></AdminPenaleListaReatoRubrica>
      <AdminPenaleProcedure v-if="model.adminPage == AdminPages.Penale_Procedure"></AdminPenaleProcedure>
      <AdminFamigliaListaFamiglia v-if="model.adminPage == AdminPages.Famiglia_Famiglia"></AdminFamigliaListaFamiglia>
      <AdminResponsabilitaListaResponsabilita v-if="model.adminPage == AdminPages.Responsabilita_Responsabilita"></AdminResponsabilitaListaResponsabilita>
    </div>
  </div>
</template>